import FooterContact from './FooterContact.vue';
import { type FooterContactItemProps } from 'ewi-ui/components/2-molecules/FooterContactItem';
import type { Meta, StoryObj } from '@storybook/vue3';

const meta = {
  title: 'Organisms/Footer Contact',
  tags: ['autodocs'],
  component: FooterContact,
  argTypes: {
    titleContent: {
      control: 'text',
    },
  },
  args: {},
} satisfies Meta<typeof FooterContact>;
export default meta;
type Story = StoryObj<typeof meta>;

const defaultContactItems = [
  {
    heading: 'Häufige Fragen',
    paragraph: 'Hier findest du eine schnelle Antwort auf die meisten Fragen.',
    icon: 'faq',
    buttonContent: 'FAQ',
  },
  {
    heading: 'Kundenportal',
    paragraph: 'Hier kannst du deine Daten einsehen und bequem verwalten.',
    icon: 'userMale',
    buttonContent: 'Kundenportal',
  },
  {
    heading: 'Chat Messenger',
    paragraph: 'Wir sind für dich da und beantworten gerne deine Fragen.',
    icon: 'bubble',
    buttonContent: 'Chat öffnen',
    headingStatus: 'green',
    id: 'chat-container--footer',
  },
  {
    heading: 'Hotline',
    paragraph: 'Du bist Interessent:in?',
    paragraphPopover:
      'Mo. bis Fr. 08:00 bis 20:00 Uhr<br />Sa. 08:00 bis 15:00 Uhr',
    icon: 'headphone',
    buttonContent: '0800 / 44 11 800',
    secondParagraph: 'Du bist bereits Kund:in?',
    secondButtonContent: '0221 / 789 658 00',
    secondParagraphPopover:
      'Mo. bis Fr. 08:00 bis 20:00 Uhr<br />Sa. 08:00 bis 15:00 Uhr',
    headingStatus: 'green',
  },
];

export const Default: Story = {
  args: {
    ...meta.args,
    titleContent: 'Wir beantworten gerne deine Fragen.',
    contactItems: defaultContactItems as FooterContactItemProps[],
  },
};

export const ThreeCards: Story = {
  args: {
    ...meta.args,
    titleContent: 'Wir beantworten gerne deine Fragen.',
    contactItems: defaultContactItems.slice(0, 3) as FooterContactItemProps[],
  },
};

export const TwoCards: Story = {
  args: {
    ...meta.args,
    titleContent: 'Wir beantworten gerne deine Fragen.',
    contactItems: defaultContactItems.slice(0, 2) as FooterContactItemProps[],
  },
};
